
import {example} from './example'
import { notification } from './noticefication'

export let KoTrans = {
     example: example,
     notification: notification
}